import { useEffect } from "react";
import PageLayout from "../../components/PageLayout";
import { apiEndpoints, appRoutes } from "../../constants/ApplicationConstants";
import { useDispatch, useSelector } from "react-redux";
import { setPageMessage, setProcessing } from "../../store/ApplicationStore";
import { saveSelectedDomainToStore, saveSelectedProcessToStore, saveSelectedSubProcessToStore, storeMenu } from "../../store/UserMenuStore";
import MenuSerializer from "../../serializers/MenuSerializer";
import { getRequest } from "../../utils/ApiUtil";
import { Box, Grid, FormControl, MenuItem, InputLabel, Select, Typography, List, ListItem } from "@mui/material";
//import { ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import nogroup from '../../assets/images/nogroup.svg';
import groupreject from '../../assets/images/groupreject.svg';
import { useHandleError } from "../others/ErrorScreen";
import { clearActiveChat, clearActiveChatId, clearThreads } from "../../store/ThreadStore";

export default function MenuScreen(){
    const { menu, selectedDomain } = useSelector(state => state.menu);
    const { user } = useSelector(state => state.user);
    //const [ menuHover, setMenuHover ]= useState(null);
    const dispatch= useDispatch();
    const navigate= useNavigate();
    const handleError=useHandleError()
    useEffect(()=> {
        async function fetchMenus(){
            try
            {
                dispatch(setProcessing(true));
                const response= await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.menu);
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    const fetchedMenus= response.data&&response.data.map((menu)=>{
                        return MenuSerializer(menu)
                    }).filter(obj=>obj)
                    dispatch(storeMenu(fetchedMenus));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
                }
            }
            catch(err)
            {
                handleError(err)
            }          
        }
        if(!menu && user.group_id){
            fetchMenus();
        }
    },[dispatch, menu, user,handleError])

    function handleDomainChange(e){
        dispatch(saveSelectedDomainToStore(e.target.value));
    }

    function handleSubProcessSelection(subprocess){
        if(subprocess)
        {
            dispatch(clearActiveChat());
            dispatch(clearActiveChatId());
            dispatch(clearThreads());
            dispatch(saveSelectedProcessToStore(subprocess.parent));
            dispatch(saveSelectedSubProcessToStore(subprocess.id));
            navigate(appRoutes.chat); 
        }    
    }

    return(
        <PageLayout header={true} footer={true}>
            <Box mt={4}>
                {user&&user.group_id&& user.is_active && <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={3} sx={{py: '1rem'}}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Select Domain</InputLabel>
                            <Select value={selectedDomain? selectedDomain : ""} label="Select Domain" onChange={(e)=>handleDomainChange(e)}>
                                {menu&&menu.filter(item=> item.parent === "").map((obj)=>{
                                    return <MenuItem key={obj.id} value={obj.id}>{obj.name}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sx={{py: '1rem', borderTop: '1px solid lightgrey'}}>
                        <Grid container spacing={2}>
                            {menu&&menu.filter(process => process.domain === selectedDomain && process.parent === selectedDomain).map((processItem)=>{
                                return<Grid key={processItem.id} item xs={12} sm={6} md={4} lg={4}>
                                    <Box>
                                        <Typography fontWeight="bold" color="secondary">{processItem.name}</Typography>
                                        <List dense={false}>
                                            {menu&&menu.filter(subProcess => subProcess.domain === selectedDomain && subProcess.parent === processItem.id).map((subProcessItem)=>{
                                                return <ListItem key={subProcessItem.id} disableGutters>
                                                    <Box display="flex" alignItems="center" justifyContent='space-between'> {/*onMouseEnter={()=>setMenuHover(subProcessItem)} onMouseLeave={()=>setMenuHover(null)}*/}
                                                        <Typography sx={{cursor: "pointer", '&:hover': { fontWeight:'bold'}}} onClick={()=>handleSubProcessSelection(subProcessItem)} color="grey">{subProcessItem.name}</Typography>
                                                        {/* <ChevronRight sx={(!menuHover || !(menuHover&&menuHover.id===subProcessItem.id))?{display: 'none'}:{ marginLeft: '1rem', opacity: "0.5", float: 'right'}} /> */}
                                                    </Box>
                                                </ListItem>
                                            })}
                                        </List>
                                    </Box>
                                </Grid>
                            })}
                        </Grid>
                    </Grid>
                </Grid>
                }
                {user&&!user.group_id&& user.is_active && user.group_status!==2&&<Box sx={{width: '50%', textAlign: 'center', margin: 'auto'}} display='flex' justifyContent='center' ><Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h4">Welcome to Cora Knowledge Assist</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{opacity: 0.8, marginTop: '2rem'}} variant="subtitle2">At the moment, there aren’t any domains mapped to your account. The admin has been alerted about your request. We will let you know once your domains are ready.</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <img alt="nogroup" src={nogroup} style={{ width: '75%', height: '75%', marginTop: '2rem' }} />
                        </Grid>
                    </Grid></Box>
                }
                {user&&!user.group_id&& user.is_active && user.group_status===2&&<Box sx={{width: '50%', textAlign: 'center', margin: 'auto'}} display='flex' justifyContent='center' ><Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h4">Welcome to Cora Knowledge Assist</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{opacity: 0.8, marginTop: '2rem'}} variant="subtitle2">Oops! Your request has been denied by the admin. Please reach out to admin@cka.com for further assistance.</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <img alt="groupreject" src={groupreject} style={{ width: '75%', height: '75%', marginTop: '2rem' }} />
                        </Grid>
                    </Grid></Box>
                }
                {user&& !user.is_active && <Box sx={{width: '50%', textAlign: 'center', margin: 'auto'}} display='flex' justifyContent='center' ><Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h4">Welcome to Cora Knowledge Assist</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{opacity: 0.8, marginTop: '2rem'}} variant="subtitle2">Oops! At the moment,this user has been deactivated.Please reach out to admin@cka.com for further assistance.</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <img alt="groupreject" src={groupreject} style={{ width: '75%', height: '75%', marginTop: '2rem' }} />
                        </Grid>
                    </Grid></Box>
                }


            </Box>
        </PageLayout>
    )
}